// i18n area 'vms' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.da-DK.meta.json.
import type { enUS } from './vms'

export const daDK: typeof enUS = {
  vms: {
    spof: {
      title: 'Uafhængighed af noden',
      single: 'Enkelt fejlpunkt',
      alternativesNow: 'Alternativer nu',
      structural: 'Efter konstruktion',
      binding: 'Bindende begrænsning',
      movableNow: 'Kan migreres nu',
    },
    title: 'Virtuelle maskiner',
    migratingChip: 'Migrering i gang',
    templateChip: 'Template',
    expendableTooltip: 'I en degraderet klynge er den blandt de første, der stoppes, og genstarter muligvis ikke efter tab af en node.',
    expendableHaTooltip: 'Genstartes altid, så længe klyngen er sund; i en degraderet klynge kommer beskyttede VM\'er først — den kan stoppes eller forblive slukket, indtil klyngen igen er hel, hvorefter den vender tilbage af sig selv.',
    viewDetails: 'Vis detaljer',
    profileLegacy: 'Andet OS',
    hugePagesNone: 'Ingen — almindelig hukommelse',
    hugePages2M: '2 MiB-sider',
    hugePages1G: '1 GiB-sider',
    searchPlaceholder: 'Søg efter navn',
    name: 'Navn',
    vcpus: 'vCPU',
    memory: 'Hukommelse',
    ipAddresses: 'IP-adresser',
    noIp: 'Ingen IP',
    authorityNode: 'Authority',
    authorityNextStart: 'tildeles ved næste start',
    scope: 'Scope',
    empty: 'Ingen virtuelle maskiner',
    loadError: 'Kunne ikke indlæse de virtuelle maskiner — kan TVirt-backenden nås?',
    filterOverlay: 'overlay-netværk',
    filterDisk: 'disk',
    filterImage: 'image',
    filteredBy: 'Filtreret efter {kind}',
    filterPhase: 'Fase',
    filterProtection: 'Beskyttelse',
    filterAll: 'Alle',
    filterScopePlaceholder: 'Filtrer efter scope',
    filtersToggle: 'Filtre',
    scopeTree: {
      title: 'Scope',
      all: 'Hele clusteret',
      noChildren: 'Intet under-scope her',
      recursive: 'Medtag underliggende',
      collapse: 'Sammenfold scope-panelet',
      up: 'Gå et niveau op',
      countTooltip: "{direct} VM'er i dette scope · {total} med underliggende"
    },
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Uden for de synlige kataloger',
      noIsos: 'Intet ISO-image klar i dette katalog'
    },
    actionsHeader: 'Handlinger',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tags',
      age: 'Alder',
      disk: 'disk',
      disks: 'diske',
      empty: 'Ingen templates — marker en slukket VM som template, eller klon en VM som template.',
      clone: 'Klon / deploy',
      editTags: 'Rediger tags',
      exportAction: 'Eksporter til kataloget (.tvtpl)',
      exportTitle: 'Eksporter til kataloget',
      exportSubmit: 'Eksporter',
      exportError: 'Eksporten mislykkedes',
      exportHint: "Templaten pakkes ind i et .tvtpl-arkiv (hardware-manifest + hver disk fladet ud til qcow2) som en ny Template VM-fil i det valgte katalog. NIC'er, CD/DVD-medier og cloud-init følger ikke med — formatets spec opregner hver bevidste udeladelse.",
      exportName: 'Filnavn',
      exportNameHint: 'Tomt = <template>-export-<n>',
      exportStorageDefault: 'Templatens metadata-storage',
      importAction: 'Importer fra katalog',
      importTitle: 'Importer fra katalog',
      importHint: 'En ready Template VM-fil fra det valgte katalog bliver til en template i inventaret: filens format (tvtpl, ova, ovf eller nøgen qcow2) afgør selv, hvordan den importeres — du vælger kun filen.',
      importFile: 'Katalogfil',
      importFileHint: 'Kun ready-filer kan importeres — en fil midt i et upload kan ikke importeres',
      importNoFiles: 'Ingen ready Template VM-filer i dette katalog — upload eller eksporter først en'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-kompatibilitet',
      quickDeployNone: 'Ikke erklæret',
      quickDeployHint: 'Erklær den kun, hvis golden-imaget indeholder cloud-init (Linux) eller cloudbase-init efter sysprep /generalize (Windows): platformen stoler på erklæringen og kigger aldrig ind i guesten.',
      notFound: 'Template ikke fundet',
      frozen: 'Hardwarekonfigurationen er frosset: konverter templaten tilbage til VM for at ændre den. Navn, noter og tags kan stadig redigeres.',
      storage: 'Storage',
      size: 'Størrelse',
      configTitle: 'Konfiguration (frosset)',
      usbClasses: 'Krævede USB-klasser',
      gpuClasses: 'Krævede GPU-klasser'
    },
    sharedDisksTab: {
      title: 'Delte diske',
      sharing: 'Deling',
      sharingNone: 'Én tilkobling',
      sharingMultiwriter: 'Delt skrivning (multiwriter)',
      sharingReadonly: 'Delt skrivebeskyttet',
      usedBy: 'I brug af',
      attachedTo: 'Tilkoblet',
      notAttached: 'Ikke tilkoblet nogen VM',
      changeSharing: 'Skift delingstilstand',
      changeSharingTitle: 'Delingstilstand',
      changeSharingLocked: 'Tilstanden kan kun ændres, mens ingen VM bruger disken',
      sharingChanged: 'Delingstilstand opdateret.',
      lun: 'Hel LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serienummer',
      antiAffinityWarning: 'To eller flere medlemmer kører på samme node uden en anti-affinitetsregel: ét nodenedbrud tager dem alle med',
      antiAffinityCreate: 'Opret reglen',
      createSourceLun: 'Overtag en hel LUN fra targetet',
      createLunNumber: 'LUN-nummer (namespace-id på NVMe)',
      createLunHint: 'Intet allokeres: størrelsen aflæses fra enheden ved overtagelsen',
      noPr: 'Ingen SCSI-3 persistent reservations i denne udgave: en Windows Failover Cluster med klassisk delt disk er ikke valideret; klynger, der koordinerer over netværket (GFS2/OCFS2, RHEL HA, shared-disk-databaser), er'
    },
    unusedDisksTab: {
      title: 'Ubrugte diske',
      attach: 'Tilslut til en VM',
      attachTitle: 'Tilslut til en VM',
      vm: 'Virtuel maskine',
      noVms: "Ingen tilgængelige VM'er",
      noSlots: 'Intet ledigt slot på denne VM',
      create: 'Opret disk',
      createTitle: 'Opret disk',
      createSourceBlank: 'Tom disk',
      createSourceImage: 'Fra et image i kataloget',
      createImage: 'Image',
      createImageEmpty: 'Intet klart VM-skabelon-image i de synlige kataloger',
      createSizeFromImageHint: 'Forudfyldt med imagets virtuelle størrelse — den kan kun vokse',
      convert: 'Konverter til VM-template…',
      convertOnlyQcow2: 'Kun qcow2-diske kan konverteres — raw er ikke et format, der kan registreres som template',
      convertTitle: 'Konverter til VM-template',
      convertSubmit: 'Konverter (destruerer disken)',
      convertError: 'Kunne ikke starte konverteringen',
      convertWarning: 'DESTRUKTIVT: disken bliver til en VM-template-fil i det valgte katalog — samme storage, nul bytes kopieret — og OPHØRER MED AT EKSISTERE som disk. Der er ingen vej tilbage ud over at oprette en ny disk fra templaten.',
      convertNameHint: 'Katalogfilens navn — som standard diskens',
      convertConfirm: 'Jeg har forstået: disken bliver destrueret',
      convertStarted: 'Konvertering startet — templaten dukker op i kataloget, når tasken er færdig.',
      storageLockHint: 'Storage ændres kun med handlingen Flyt',
      source: 'Oprindelse',
      sourceClone: 'Klon af en anden disk',
      sourceCloneLinked: 'Linked clone af en anden disk',
      sourceImage: 'Oprettet fra et image',
      sourceBlank: 'Oprettet tom',
      allocated: 'Allokeret / virtuel størrelse',
      observedAt: 'Observeret',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Ingen snapshots'
    },
    phase: {
      defined: 'Aldrig tændt',
      starting: 'Starter',
      running: 'Kører',
      stopping: 'Stopper',
      stopped: 'Slukket',
      paused: 'På pause',
      failed: 'I fejltilstand',
      deleting: 'Under sletning'
    },
    stopCause: {
      'api': 'Stoppet af TVirt (handling eller API)',
      'guest-shutdown': 'Shutdown startet af guest-operativsystemet',
      'crash': 'Crash i guesten',
      'qemu-exit': 'QEMU-processen afsluttede uventet',
      'host-reboot': 'Noden blev genstartet',
      'migrated': 'Migreret til en anden node',
      'fenced': 'Termineret af HA-fencing (noden vendte tilbage)'
    },
    detail: {
      notFound: 'Virtuel maskine ikke fundet',
      details: 'Detaljer',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardwareprofil',
      firmware: 'Firmware',
      firmwareFile: 'UEFI-firmwareversion',
      firmwareUpdate: 'Opdatering tilgængelig',
      firmwareUpdateHint: "Platformen leverer en nyere UEFI-firmware. Opdateringen sker aldrig automatisk: den anvendes, når VM'en er slukket, og når du beslutter det.",
      arch: 'Arkitektur',
      node: 'Node',
      bootOrder: 'Bootrækkefølge',
      agent: 'Agentstatus',
      agentConnected: 'Forbundet',
      agentNotConnected: 'Ikke forbundet',
      protected: 'Beskyttet',
      linkedClones: 'Forbundne kloner',
      restartPolicy: 'Genstartspolitik',
      preferredNode: 'Foretrukken node',
      noPreference: 'Ingen præference (automatisk placement)',
      preferNodes: 'Foretrukne node-tags',
      requireNodes: 'Påkrævede node-tags',
      noPlacementTags: 'Ingen',
      placementTag: 'Tag',
      placementValue: 'Værdi',
      placementAddTag: 'Tilføj tag',
      proximityHa: 'HA i TVirt Proximity',
      proximityHaRestarts: 'HA-genstarter',
      proximityHaGaveUp: 'crash loop — HA har givet op',
      failoverProtection: 'Beskyttelse i degraderet klynge',
      protectionProtected: 'Beskyttet',
      protectionExpendable: 'Kan ofres ved degradering',
      protectionInherit: 'Arv',
      lastStop: 'Seneste stop',
      yes: 'Ja',
      no: 'Nej',
      tabOverview: 'Oversigt',
      tabSnapshots: 'Snapshots',
      tabBackups: 'Kopier',
      hardware: 'Hardware',
      name: 'Navn',
      hwSystem: 'System',
      hwCpu: 'CPU',
      hwMemory: 'Hukommelse',
      hwBoot: 'Opstart',
      hwIdentity: 'Identitet',
      hwCluster: 'Cluster og agent',
      cpuTopology: 'CPU-topologi',
      cpuModel: 'CPU-model',
      cpuLimit: 'CPU-grænse',
      cpuWeight: 'CPU-vægt',
      cpuNested: "Indlejret virtualisering",
      cpuNestedHint: "Eksponerer vmx/svm for gæsten (kun med CPU-modellen host). På en kørende VM gælder ændringen fra næste power cycle (PendingRestart); placering tillader kun noder med nested aktiveret.",
      unlimited: 'Ubegrænset',
      memory: 'Hukommelse',
      balloon: 'Balloon',
      hugePages: 'Enorme sider',
      hugePagesTradeoff: 'Mindre adresseoversættelsesarbejde og hukommelse, der aldrig havner på disken; til gengæld er reservationen låst på noden, så længe den virtuelle maskine kører, hukommelsen deduplikerés ikke længere, og starten fejler, hvis noden har for få ledige sider.',
      disks: 'Diske',
      cdroms: 'CD/DVD-drev',
      nics: 'Netværksinterfaces',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Krypteret',
      image: 'Image',
      emptyDrive: 'Tomt drev',
      emptyOption: '(tom)',
      network: 'Netværk',
      mac: 'MAC',
      connected: 'Tilsluttet',
      unplugged: 'Frakoblet',
      noDevices: 'Ingen',
      screenshot: 'Screenshot',
      capturedAt: 'Taget kl.',
      noCapture: 'Ingen optagelse',
      snapshotName: 'Navn',
      snapshotCreated: 'Oprettet',
      snapshotMemory: 'Hukommelse inkluderet',
      noSnapshots: 'Ingen snapshots',
      pendingRestart: 'Afventende ændringer: de træder i kraft ved næste power cycle.',
      applied: 'anvendt',
      appliedHint: "VM'en kører med denne værdi — den konfigurerede træder i kraft ved næste power cycle.",
      actionError: 'Handlingen mislykkedes',
      actionStillRunning: 'Handlingen er stadig i gang — resultatet kendes endnu ikke',
      tabConsole: 'Konsol',
      consoleConnect: 'Forbind',
      consoleDisconnect: 'Frakobl',
      consoleConnecting: 'Forbinder…',
      consoleReconnecting: 'Forbinder…',
      consoleUnavailable: "Konsollen er tilgængelig, når VM'en kører eller er på pause.",
      consoleError: 'Forbindelsen til konsollen mislykkedes',
      consoleTaken: 'Konsolsessionen er overtaget af {user}',
      consoleReconnect: 'Forbind igen',
      consoleCtrlAltDel: 'Ctrl+Alt+Delete',
      consoleHold: 'Hold {key} nede',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Åbn i fuld skærm i en ny fane',
      consoleLoadFailed: 'VM ikke fundet eller utilstrækkelige rettigheder',
      consoleClose: 'Luk',
      tabStats: 'Statistik',
      tabTasks: 'Tasks',
      tabLogs: 'Log',
      statsCpu: 'CPU',
      statsMemory: 'Hukommelse',
      statsDisk: 'Disk-I/O',
      statsRange: 'Interval',
      statsNoData: "Ingen data i intervallet — statistikken samples, mens VM'en kører.",
      statsError: 'Kunne ikke indlæse statistikken',
      cpuUsage: 'Forbrug',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Brugt',
      memGuestAvailable: 'Tilgængelig (guest)',
      schema: 'Schema',
      consoleProtocol: 'Konsol',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Metadata-storage',
      startupOnBoot: 'Start ved boot',
      startupOrder: 'Startrækkefølge',
      startupDelay: 'Startforsinkelse',
      seconds: 's',
      enabled: 'Aktiveret',
      disabled: 'Deaktiveret'
    },
    actionsAvailable: 'Tilgængelige handlinger',
    actions: {
      start: 'Start',
      stop: 'Stop',
      pause: 'Pause',
      resume: 'Genoptag',
      reset: 'Reset',
      migrate: 'Migrer',
      clone: 'Klon',
      moveStorage: 'Flyt til storage…',
      moveScope: 'Flyt til scope…',
      openConsole: 'Åbn konsol',
      forceStop: 'Fremtving slukning',
      markTemplate: 'Marker som template',
      unmarkTemplate: 'Konverter tilbage til VM',
      error: 'Kunne ikke udføre handlingen'
    },
    cordon: {
      confirmTitle: 'Noden er i vedligeholdelse',
      confirmHint:
        'Kordonen kan ikke sænkes, mens klyngens store er nede. Ved at bekræfte erklærer du, at du ved det: den virtuelle maskine tændes der alligevel, og samtykket registreres på opgaven.',
      confirm: 'Tænd alligevel'
    },
    markTemplate: {
      confirmTitle: 'Markere {name} som template?',
      confirmBody: "Konfigurationen fryses, og VM'en kan ikke længere tændes — kun klones eller blive VM igen. Navn, noter og tags kan stadig redigeres.",
      confirm: 'Marker som template',
      moved: '{name} er nu en template — den er flyttet til fanen Templates.'
    },
    unmarkTemplate: {
      confirmTitle: 'Konvertere {name} tilbage til VM?',
      confirmBody: 'Templaten bliver igen en almindelig VM: den kan redigeres og startes (næste start placerer den på en node).',
      confirm: 'Konverter tilbage til VM',
      moved: '{name} er igen en virtuel maskine — den er flyttet til fanen Virtuelle maskiner.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Efter node-tag',
      hint: 'tag=værdi, kommasepareret (AND): decideren vælger blandt de matchende noder',
      invalid: 'Ugyldigt format — brug tag=værdi, kommasepareret',
      resolved: 'Matchende medlemmer: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migrer',
      target: 'Destinationsnode',
      auto: 'Automatisk (Proximity)',
      hint: "VM'en flyttes uden power cycle. Al storage, den rører, skal være delt; en VM på pause migrerer på pause.",
      error: 'Migreringen blev afvist'
    },
    moveStorage: {
      title: 'Flyt til storage',
      submit: 'Flyt',
      target: 'Destinations-storage',
      noTargets: 'Ingen storage accepterer diske',
      hint: "Alle den slukkede VM's diske flyttes til den valgte storage, én ad gangen, og beholder deres id — dem, der allerede er på destinationen, springes over. Fremdriften bor på task-siden.",
      error: 'Flytningen blev afvist'
    },
    moveScope: {
      title: 'Flyt til scope',
      submit: 'Flyt',
      target: 'Destinations-scope',
      hint: "VM'en skifter scope med det samme — id og diske består, de owned diske følger med, og den kan forblive tændt. I dag bor den i {scope}. Hvem der ser den, ændrer sig med scopet.",
      error: 'Scope-flytningen blev afvist'
    },
    start: {
      title: 'Start VM',
      submit: 'Start',
      target: 'Destinationsnode',
      auto: 'Automatisk (anbefalet)',
      recommended: 'anbefalet',
      hint: 'Vælg en destinationsnode, eller lad Proximity vælge blandt de gyldige kandidater. Noder, der ikke kan huse den, er deaktiveret med begrundelsen.',
      error: "Kunne ikke starte VM'en"
    },
    console: {
      media: 'CD/DVD-drev',
      mediaGuestToolsHint: 'Indeholder TVirt Guest Tools — herfra kan du skubbe dem ud eller fjerne drevet',
      slotOpsDeferred: 'På denne profil træder tilføjelse og fjernelse af drev i kraft ved næste power cycle (medieskift er øjeblikkelige).',
      mountGuestTools: 'Monter TVirt Guest Tools',
      ejectGuestTools: 'Skub TVirt Guest Tools ud',
      bootOrder: 'Bootrækkefølge',
      bootOrderHint: 'Den nye rækkefølge gemmes straks og træder i kraft ved næste power cycle — konsolsessionen forbliver tilsluttet.'
    },
    snapshots: {
      create: 'Opret snapshot',
      createTitle: 'Opret et snapshot',
      createSubmit: 'Opret',
      name: 'Navn',
      nameHint: 'Bogstaver, cifre, punktum, bindestreg, underscore.',
      consistencyHint: "Konsistensen er automatisk: guest-agenten fryser filsystemerne, når den svarer; ellers sættes VM'en på pause et øjeblik omkring snapshottet.",
      memory: 'Inkluder hukommelsen',
      memoryHint: "Fanger den levende RAM: gendannelsen genoptager VM'en i kørende tilstand. Kræver, at alle diske er qcow2.",
      currentChip: 'Du er her',
      revert: 'Gendan',
      revertTitle: 'Gendanne {name}?',
      revertBody: "Diskene vender tilbage til snapshottets tilstand; alt, hvad der er sket siden, går tabt. Et snapshot med kun diske kræver, at VM'en er stoppet.",
      delete: 'Slet',
      deleteTitle: 'Slette snapshottet {name}?',
      deleteBody: 'Gendannelsespunktet forsvinder; diskenes indhold forbliver intakt.',
      deleteMergeHint: 'Dets delta flettes ind i {children}: ethvert senere gendannelsespunkt forbliver gyldigt.',
      deleteDuplication: 'Jeg accepterer dubleringen',
      deleteDuplicationHint: 'Deltaet kopieres ind i hver af de {count} læsere (børne-snapshots og, hvis dette er det aktuelle, det aktive hoved): den brugte plads kan vokse i stedet for at skrumpe.',
      error: 'Snapshot-operationen blev afvist'
    },
    clone: {
      title: 'Klon VM',
      submit: 'Klon',
      name: 'Kopiens navn',
      storage: 'Destinations-storage for diskene',
      sameStorage: 'Samme som kilden',
      full: 'Fuld kopi',
      fullHint: 'Kopierer hver byte og kapper båndet til kildediskene. Standard er en linked clone: øjeblikkelig, men lænket til kilden (kun qcow2).',
      hint: 'Klonen beholder kildens konfiguration og firmware; MAC-adresser og TPM-identitet er nye.',
      markAs: 'Klonens type',
      markAsInheritVm: 'Som kilden (VM)',
      markAsInheritTemplate: 'Som kilden (template)',
      markAsVm: 'Virtuel maskine',
      markAsTemplate: 'Template',
      markAsHintVm: 'Vælg Template for at forfremme kopien i ét trin.',
      markAsHintTemplate: 'Vælg Virtuel maskine for at deploye fra denne template i ét trin.',
      error: 'Kloningen blev afvist'
    },
    bulk: {
      selected: 'valgt',
      deleteTitle: {
        one: 'Slette {count} valgt VM?',
        other: "Slette {count} valgte VM'er?"
      },
      deleteBody: 'Hver VM går gennem de samme kontroller som en enkelt sletning; afvisninger rapporteres pr. element.',
      done: 'accepteret',
      refused: 'afvist'
    },
    delete: {
      button: 'Slet',
      confirmTitle: 'Slette {name}?',
      confirmBody: 'Den virtuelle maskine og de diske, den ejer, bliver slettet. Operationen kan ikke fortrydes.',
      keepDisks: 'Behold diskene',
      keepDisksHint: "Diske oprettet sammen med VM'en bliver i deres storage som selvstændige diske.",
      confirm: 'Slet',
      cancel: 'Annuller',
      error: 'Sletningen mislykkedes',
      blockedPhase: "Stop VM'en først",
      blockedProtected: "VM'en er beskyttet — fjern først beskyttelsen",
      blockedDeleting: 'Sletning allerede i gang'
    },
    logs: {
      title: 'Log',
      subtitle: 'Strukturerede log-frames fra de tasks, der rører denne VM',
      when: 'Hvornår',
      task: 'Task',
      level: 'Niveau',
      message: 'Besked',
      empty: 'Ingen log endnu',
      loadError: 'Kunne ikke indlæse loggen — kan TVirt-backenden nås?'
    },
    stop: {
      title: 'Stop virtuel maskine',
      modeGraceful: 'Graceful slukning',
      modeGracefulHint: 'Guest-operativsystemet bliver bedt om at lukke ned på naturlig vis (ACPI); ignorerer det anmodningen, udløses den fremtvungne slukning efter timeoutet.',
      modeForced: 'Fremtvungen slukning',
      modeForcedHint: 'Afbryder strømmen med det samme, som at trække stikket.',
      timeout: 'Fallback-timeout (sekunder)',
      timeoutHint: 'Ventetid, guesten får, før slukningen fremtvinges'
    },
    createFromScratch: 'Fra bunden',
    createFromTemplate: 'Fra template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Udfør deploy',
      error: 'Deploy mislykkedes',
      compatNote: 'QuickDeploy kræver en QuickDeploy-kompatibel template: platformen tilpasser guesten (netværk, domæne, aktivering) ved første start.',
      template: 'Template',
      noTemplates: 'Ingen template erklærer QuickDeploy-kompatibilitet endnu — erklær den fra fanen Templates (Linux med cloud-init, Windows med cloudbase-init efter sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Værtsnavn',
      hostnameHint: 'Værtsnavn eller FQDN; tomt = VM\'ens navn (Windows: højst 15 tegn)',
      ip: 'IP-adresse',
      ipHint: 'Vært og præfiks, fx 192.168.122.101/24; tomt = DHCP',
      gateway: 'Gateway',
      dns: 'DNS-servere',
      dnsHint: 'Op til tre, adskilt med komma',
      count: 'Instanser',
      countHint: 'Mere end én: navngivet <navn>-1…-N, kun DHCP',
      user: 'Bruger',
      userHint: 'Tomt = imagets standardbruger (Linux) eller Administrator (Windows)',
      password: 'Adgangskode',
      passwordHint: 'Skrives ind i den genererede user-data, som platformen derefter erklærer hemmelig: ingen læser den igen',
      sshKeys: 'Offentlige SSH-nøgler',
      sshKeysHint: 'Én pr. linje (ssh-ed25519 AAAA… kommentar)',
      productKey: 'Windows-produktnøgle',
      kmsServer: 'KMS-server',
      kmsHint: 'Vært eller vært:port — kræver en produktnøgle (en KMS-klientnøgle)',
      adDomain: 'Join Active Directory-domæne',
      adDomainHint: 'Tomt = ingen domæne-join',
      adUser: 'Join-konto',
      adPassword: 'Join-kontoens adgangskode',
      adOu: 'Mål-OU (valgfri)',
      advanced: 'Avanceret: rå dokumenter',
      userData: 'user-data (rå)',
      userDataHint: 'Tilsidesætter den genererede user-data: bruger, adgangskode, nøgler og Windows-felterne ovenfor skal forblive tomme',
      networkConfig: 'network-config (rå)',
      networkConfigHint: 'Tilsidesætter det genererede netværk: IP, gateway og DNS ovenfor skal forblive tomme',
      secret: 'Behandl den rå user-data som hemmelig',
      secretHint: 'Markeret hemmelig returneres den ikke længere af API\'et til nogen og rejser forseglet med masterpass i Checkpointet',
      startNow: 'Start med det samme',
      startNowHint: 'Hver instans starter, så snart den er defineret; seedet bygges ved den start'
    },
    create: {
      nicAttachmentNetwork: 'Logisk netværk (fabric)',
      nicNetwork: 'Logisk netværk',
      nicNetworkHint: 'Den ANBEFALEDE vej (F3): vNIC\'en realiseres på den AFLEDTE bridge på den betjenende node — bridgen fødes ved den eksplicitte fabric-apply, og en start på en node, der endnu ikke bærer den, afviser talende. Når flådens sidste reference forsvinder, falder bridgen ud ved næste apply.',
      button: 'Opret VM',
      title: 'Opret virtuel maskine',
      dialogTitle: 'Opret virtuel maskine',
      stepGeneral: 'Generelt',
      stepGeneralHint: 'Navn og profil',
      stepCompute: 'CPU og RAM',
      stepComputeHint: 'Topologi og størrelser',
      stepDisks: 'Diske',
      stepDisksHint: 'Opret eller tilslut',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Drev og medier',
      stepNetwork: 'Netværk',
      stepNetworkHint: 'NIC: trunk eller bridge',
      stepSummary: 'Opsummering',
      stepSummaryHint: 'Gennemgå og opret',
      name: 'Navn',
      nameHint: 'Små bogstaver, cifre og bindestreger (DNS-1123)',
      nextButton: 'Næste',
      prevButton: 'Tilbage',
      submitButton: 'Opret',
      creating: 'Opretter…',
      sockets: 'Sockets',
      cores: 'Kerner pr. socket',
      threads: 'Tråde pr. kerne',
      totalVcpus: 'vCPU i alt',
      memoryGib: 'Hukommelse (GiB)',
      cpuModelHint: "'host' eksponerer hostens CPU",
      cpuLimitHint: 'Loft i host-kerner — tom = ubegrænset',
      cpuNestedHint: "Eksponerer vmx/svm for gæsten, så den kan køre sin egen hypervisor — kræver CPU-modellen host og en node med nested aktiveret",
      newDisk: 'Ny disk',
      attachDisk: 'Tilslut eksisterende disk',
      diskStorage: 'Storage',
      diskSize: 'Størrelse (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Tilføj disk',
      addCdrom: 'Tilføj CD/DVD-drev',
      addNic: 'Tilføj netværksinterface',
      remove: 'Fjern',
      slotLimit: 'Slot-grænsen er nået',
      cdromImage: 'Image (tomt drev hvis udeladt)',
      nicAttachment: 'Tilkobling',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Host-bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Ingen (kun tagged)',
      nicTrunkHint: "Mindst én side: et untagged overlay og/eller taggede VLAN-mapninger — VM'en kan kun køre på de hosts, som hvert refereret overlay erklærer",
      nicTaggedVlan: 'VLAN-ID',
      nicTaggedOverlay: 'Overlay-netværk',
      addTagged: 'Tilføj tagged VLAN',
      nicBridge: 'Navn på host-bridgen',
      nicBridgeHint: "NM-bridge efter navn — VM'en kan kun køre på de servere, hvis host network erklærer denne bridge",
      nicMac: 'MAC (auto hvis tom)',
      noDisksHint: "Ingen diske: VM'en får kun de CD/DVD-drev, du tilføjer.",
      noCdromsHint: 'Intet CD/DVD-drev: tilføj et for at boote fra et ISO-image.',
      mountGuestTools: 'Monter TVirt Guest Tools ved første start',
      mountGuestToolsHint: "Lægger ISO'en med virtio-driverne og guest-agenten i et tomt CD-drev (tilføjes om nødvendigt) — Windows-installeren har brug for den for at kunne se diskene.",
      noNicsHint: "Intet netværksinterface: VM'en starter uden netværksforbindelse.",
      taggedMappings: 'Taggede VLAN-mapninger',
      summaryDevices: 'Enheder',
      bootOrderTitle: 'Bootrækkefølge',
      bootOrderHint: "Træk for at ændre rækkefølgen — den første bootbare enhed vinder; NIC'er booter PXE",
      bootOrderUp: 'Flyt op',
      bootOrderDown: 'Flyt ned',
      createError: 'Oprettelsen mislykkedes'
    },
    edit: {
      button: 'Rediger',
      title: 'Rediger virtuel maskine',
      cancel: 'Annuller',
      save: 'Gem',
      error: 'Redigeringen mislykkedes',
      modelStoppedOnly: "Kan kun redigeres, når VM'en er slukket",
      firmwareStoppedOnly: "Firmware kan kun ændres, når VM'en er slukket — ved næste start booter maskinen den nye firmware, og UEFI-variablerne bevares",
      hugePagesStoppedOnly: 'Kan kun ændres, når den virtuelle maskine er slukket — ved næste start opbygges hukommelsen på det nye underlag',
      runningHint: 'Ændringerne træder i kraft ved næste power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Hukommelse',
      sectionPolicy: 'Politikker'
    },
    devices: {
      networkChip: 'fabric-netværk',
      title: 'Enheder',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Tilføj USB-enhed',
      addUsbTitle: 'Anmod om en klasse af USB-enheder',
      usbClassHint: "VM'en beder om en KLASSE af USB-enheder (en værdi af et usb-device-tag), aldrig en bestemt enhed: ved start vælges og reserveres den konkrete ledige enhed på noden. Tag de registrerede enheder i Cluster › USB- og PCIe-ressourcer.",
      usbTag: 'Tag (usb-device)',
      usbValue: 'Klassens værdi',
      noUsbTags: 'Intet usb-device-tag — opret et, og tag de registrerede enheder i Cluster › USB- og PCIe-ressourcer.',
      noUsbValues: 'Dette tag har endnu ingen erklærede værdier.',
      usbEmpty: 'Ingen USB-krav — tilføj en klasse for at give en enhed videre ved start.',
      usbClassChip: 'klasse',
      usbPortChip: 'port',
      usbUnclaimed: "Ingen enhed reserveret — det afgøres, når VM'en starter.",
      addGpu: 'Tilføj GPU',
      addGpuTitle: 'Anmod om en GPU-klasse',
      gpuClassHint: "VM'en beder om en KLASSE af GPU'er (en værdi af et gpu-device-tag), aldrig et bestemt kort: ved start vælges og reserveres det konkrete ledige kort på noden, og hele dets IOMMU-gruppe gives videre SAMLET. Tag de registrerede GPU'er i Cluster › USB- og PCIe-ressourcer.",
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Klassens værdi',
      noGpuTags: "Intet gpu-device-tag — opret et, og tag de registrerede GPU'er i Cluster › USB- og PCIe-ressourcer.",
      noGpuValues: 'Dette tag har endnu ingen erklærede værdier.',
      gpuEmpty: 'Ingen GPU-krav — tilføj en klasse for at give et kort videre ved start.',
      gpuClassChip: 'klasse',
      gpuGroupChip: 'IOMMU-gruppe ×',
      gpuUnclaimed: "Intet kort reserveret — det afgøres, når VM'en starter.",
      gpuPowerCycle: 'Ingen GPU-hotplug — ændringerne gælder fra næste power cycle (PendingRestart)',
      actions: 'Handlinger',
      attachDisk: 'Tilføj disk',
      attachDiskTitle: 'Tilføj en disk',
      attach: 'Tilslut',
      noFreeDisks: 'Ingen ubrugte diske — opret en under Virtuelle maskiner › Ubrugte diske.',
      addCdrom: 'Tilføj drev',
      addCdromTitle: 'Tilføj et CD/DVD-drev',
      editCdromTitle: 'Skift CD/DVD-image',
      changeMedia: 'Skift CD/DVD-image',
      ejectMedium: 'Skub ud',
      mountGuestTools: 'Monter TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools monteret',
      guestToolsClickMount: "Lægger TVirt Guest Tools-ISO'en i det første tomme CD/DVD-drev",
      guestToolsClickUnmount: 'Klik for at skubbe ud — drevet bliver, tomt',
      guestToolsNoSlot: 'Intet tomt CD/DVD-drev — tilføj et drev (eller skub et medie ud) for at montere TVirt Guest Tools',
      guestToolsSkew: 'Monteret v{pinned}; node {node} leverer nu v{current}: skub ud og montér igen for at opdatere',
      ejectGuestTools: 'Skub TVirt Guest Tools ud (drevet bliver, tomt)',
      guestToolsEjectConfirmTitle: 'Skubbe TVirt Guest Tools ud?',
      guestToolsEjectConfirmBody: 'Mediet skubbes ud af den tændte VM — CD/DVD-drevet bliver, tomt.',
      applyLive: "Anvend med det samme (VM'en er tændt)",
      addNic: 'Tilføj interface',
      addNicTitle: 'Tilføj et netværksinterface',
      editNicTitle: 'Rediger netværksinterface',
      bridgeChip: 'bridge',
      cable: 'Virtuelt kabel',
      plug: 'Tilslut det virtuelle kabel',
      unplug: 'Frakobl det virtuelle kabel',
      remove: 'Fjern',
      removeTitle: 'Fjerne {device}?',
      removeBody: 'På en tændt VM træder ændringen i kraft ved næste power cycle. Diske og images frakobles, aldrig slettes.'
    }
  }
}
